// extracted by mini-css-extract-plugin
export default {"loader":"LoaderScanner_loader__TalAd","scanner":"LoaderScanner_scanner__Bj2Xn","scan":"LoaderScanner_scan__6Yulr"};